// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wamz","image":"Header_image__1YnSH","name":"Header_name__3C1z9","info":"Header_info__21HmU","infoRow":"Header_infoRow__iTlIW"};